import apiCall from './components/apiCall';
import { Authorization } from 'glxl-helpers';

import FB from './assets/img/icons/ministries/FB.svg';
import GZ from './assets/img/icons/ministries/GZ.svg';
import HB from './assets/img/icons/ministries/HB.svg';
import IE from './assets/img/icons/ministries/IE.svg';
import LV from './assets/img/icons/ministries/LV.svg';
import MC from './assets/img/icons/ministries/MC.svg';
import KN from './assets/img/icons/ministries/KN.svg';
import OH from './assets/img/icons/ministries/OH.svg';
import OT from './assets/img/icons/ministries/OT.svg';
import OW from './assets/img/icons/ministries/OW.svg';
import VR from './assets/img/icons/ministries/VR.svg';
import WI from './assets/img/icons/ministries/WI.svg';
import WS from './assets/img/icons/ministries/WS.svg';
import EH from './assets/img/icons/ministries/EH.svg';

import WI_Edge from "./assets/img/icons/ministries_edge/WI.png";
import GZ_Edge from "./assets/img/icons/ministries_edge/GZ.png";
import OW_Edge from "./assets/img/icons/ministries_edge/OW.png";
import OT_Edge from "./assets/img/icons/ministries_edge/OT.png";
import VR_Edge from "./assets/img/icons/ministries_edge/VR.png";
import IE_Edge from "./assets/img/icons/ministries_edge/IE.png";
import FB_Edge from "./assets/img/icons/ministries_edge/FB.png";
import LV_Edge from "./assets/img/icons/ministries_edge/LV.png";
import KN_Edge from "./assets/img/icons/ministries_edge/KN.png";
import OH_Edge from "./assets/img/icons/ministries_edge/OH.png";
import WS_Edge from "./assets/img/icons/ministries_edge/WS.png";
import HB_Edge from "./assets/img/icons/ministries_edge/HB.png";
import EH_Edge from "./assets/img/icons/ministries_edge/EH.png";
import MC_Edge from "./assets/img/icons/ministries_edge/MC.png";

// @todo needs more assets
import GR from './assets/img/ghettoradio.png';
import ER from './assets/img/escaperoute.png';
const auth = new Authorization();

let prepIcons = { FB, GZ, HB, IE, LV, MC, KN, OH, OT, OW, VR, WI, WS, EH };
if (window.navigator.userAgent.indexOf("Edge") > -1) {
  prepIcons = { FB: FB_Edge, GZ: GZ_Edge, HB: HB_Edge, IE: IE_Edge, LV: LV_Edge, MC: MC_Edge, KN: KN_Edge, OH: OH_Edge, OT: OT_Edge, OW: OW_Edge, VR: VR_Edge, WI: WI_Edge, WS: WS_Edge, EH: EH_Edge };
}
const icons = prepIcons;
const gameIcons = { GR, ER };

const position = {
  //Economie
  "economy": {
    "pro": {
      "left": 50,
      "top": 0,
    },
    "basic": {
      "left": 35,
      "top": 0,
    }
  },
  //beleidskeuzes
  "policy": {
    "left": 65,
    "top": 0,
  },
  //Werk en inkomen
  "WI": {
    "pro": {
      "left": 61.5,
      "top": 14.9,
    },
    "basic": {
      "left": 61.8,
      "top": 15.6,
    }
  },
  //Gezondheidszorg
  "GZ": {
    "pro": {
      "left": 51.6,
      "top": 31,
    },
    "basic": {
      "left": 47.6,
      "top": 54.5,
    }
  },
  //Onderwijs
  "OW": {
    "pro": {
      "left": 68.4,
      "top": 28.1,
    },
    "basic": {
      "left": 71,
      "top": 29.2,
    }
  },
  //Oorlog en terrorisme
  "OT": {
    "pro": {
      "left": 28.7,
      "top": 35.6,
    },
    "basic": {
      "left": 28.5,
      "top": 36,
    }
  },
  //Veiligheid en recht
  "VR": {
    "pro": {
      "left": 59.5,
      "top": 60.7,
    },
    "basic": {
      "left": 59.5,
      "top": 60.9,
    }
  },
  //Infrastructuur en Energie
  "IE": {
    "pro": {
      "left": 48.3,
      "top": 14.9,
    },
    "basic": {
      "left": 49.8,
      "top": 15,
    }
  },
  //Financien en bestuur
  "FB": {
    "pro": {
      "left": 36.5,
      "top": 18.7,
    },
  },
  //Landbouw en voedsel
  "LV": {
    "pro": {
      "left": 61.1,
      "top": 42.1,
    },
    "basic": {
      "left": 59.7,
      "top": 39.5,
    }
  },
  //Klimaat, natuur en milieu
  "KN": {
    "pro": {
      "left": 50.4,
      "top": 71.5,
    },
    "basic": {
      "left": 50.5,
      "top": 71.5,
    }
  },
  //Ontwikkelingshulp
  "OH": {
    "pro": {
      "left": 31.9,
      "top": 57,
    },
    "basic": {
      "left": 31.9,
      "top": 57,
    }
  },
  //Wonen en samenleven
  "WS": {
    "pro": {
      "left": 41.8,
      "top": 41.2,
    },
    "basic": {
      "left": 44,
      "top": 35.1,
    }
  },
  //Handel en bedrijven
  "HB": {
    "pro": {
      "left": 47.2,
      "top": 57.5,
    },
  },
  //Eerlijke handel
  "EH": {
    "basic": {
      "left": 36,
      "top": 18,
    }
  },
  //Media, cultuur en sport
  "MC": {
    "pro": {
      "left": 71.4,
      "top": 48.9,
    },
    "basic": {
      "left": 71.5,
      "top": 49.2,
    }
  }
};

const popupLocations = {
  "startscherm": "/portal/group",
  "teaminfo": "/portal/teaminfo",
  "listviewstap1": "/ministries",
  "winstgloba'soverzicht": "/ministries/overview/profit",
  "verliesgloba'soverzicht": "/ministries/overview/loss",
  "ministerieoverzicht": "/ministries/wi",
  "listviewstap2": "/taxes",
  "arbeidsbelastinguitvouwscherm": "/taxes/ab",
  "bedrijvenbelastinguitvouwscherm": "/taxes/bb",
  "consumentenbelastinguitvouwscherm": "/taxes/cb",
  "mens-enmilieubelastinguitvouwscherm": "/taxes/mb",
  "vermogensbelastinguitvouwscherm": "/taxes/vb",
  "listviewstap3": "/ministries",
  "overzichtsparenenlenen": "/bank",
  "ministeriepaginastap3": "/ministries/budget/ot",
  "extraopdrachten": "/portal/classleader/bonuspoints",
  "ghettoradiospel-tussenscherm": "",
  "filmquizspel-tussenscherm": "",
  "escaperoutespelscherm": "",
  "detectivesspel-tussenscherm": "",
  "overzichtstap2": "/taxes",

  "startschermbegeleider": "/portal/classleader",
  "voorbereidingbegeleider": "/portal/classleader/prepare",
  "opstartprojectbegeleiderspagina": "/portal/classleader/prepare/startup",
  "extraopdrachtenbegeleiderspagina": "/portal/classleader/bonuspoints",
  "foto'sbegeleiderspagina": "/portal/classleader/pictures",
  "filmpjesbegeleiderspagina": "/portal/classleader/videos",
  "globa'sverdelenbegeleiderspagina": "/portal/classleader/verdelen",
  "ghettoradiobegeleiderspaginaverdienspel": "/portal/classleader/verdienen/2",
  "escaperoutebegeleiderspaginaverdienspel": "/portal/classleader/verdienen/4",
  "filmquizbegeleiderspagina": "/portal/classleader/verdienen/5",
  "filmquizbegeleiderspaginaverdienspel": "/portal/classleader/verdienen/5",
  "detectivesbegeleiderspaginaverdienspel": "/portal/classleader/verdienen/6"
}

const popupLocationsDesktop = {
  "startscherm": "/portal/group",
  "teaminfo": "/portal/teaminfo",
  "listviewstap1": "/",
  "winstgloba'soverzicht": "/ministries/overview/profit",
  "verliesgloba'soverzicht": "/ministries/overview/loss",
  "ministerieoverzicht": "/ministries/wi",
  "listviewstap2": "/taxes",
  "arbeidsbelastinguitvouwscherm": "/taxes/ab",
  "bedrijvenbelastinguitvouwscherm": "/taxes/bb",
  "consumentenbelastinguitvouwscherm": "/taxes/cb",
  "mens-enmilieubelastinguitvouwscherm": "/taxes/mb",
  "vermogensbelastinguitvouwscherm": "/taxes/vb",
  "listviewstap3": "/",
  "overzichtsparenenlenen": "/bank",
  "ministeriepaginastap3": "/ministries/budget/ot",
  "extraopdrachten": "/portal/classleader/bonuspoints",
  "ghettoradiospel-tussenscherm": "",
  "filmquizspel-tussenscherm": "",
  "escaperoutespelscherm": "",
  "detectivesspel-tussenscherm": "",
  "overzichtstap2": "/taxes",

  "startschermbegeleider": "/portal/classleader",
  "voorbereidingbegeleider": "/portal/classleader/prepare",
  "opstartprojectbegeleiderspagina": "/portal/classleader/prepare/startup",
  "extraopdrachtenbegeleiderspagina": "/portal/classleader/bonuspoints",
  "foto'sbegeleiderspagina": "/portal/classleader/pictures",
  "filmpjesbegeleiderspagina": "/portal/classleader/videos",
  "globa'sverdelenbegeleiderspagina": "/portal/classleader/verdelen",
  "ghettoradiobegeleiderspaginaverdienspel": "/portal/classleader/verdienen/2",
  "escaperoutebegeleiderspaginaverdienspel": "/portal/classleader/verdienen/4",
  "filmquizbegeleiderspagina": "/portal/classleader/verdienen/5",
  "filmquizbegeleiderspaginaverdienspel": "/portal/classleader/verdienen/5",
  "detectivesbegeleiderspaginaverdienspel": "/portal/classleader/verdienen/6"
}

function matchCase(original, replacement) {
  // Alles uppercase
  if (original === original.toUpperCase()) {
    return replacement.toUpperCase();
  }

  // Eerste letter uppercase (Title case)
  if (original[0] === original[0].toUpperCase()) {
    return replacement.charAt(0).toUpperCase() + replacement.slice(1);
  }

  // Anders lowercase
  return replacement.toLowerCase();
}


class Defines {
  static async fetch() {
    const data = await apiCall('/define/simulationgame?simulationgame=true');
    let popups = await apiCall('/simulatiespel/popups?simulationgame=true');
    if (popups && typeof popups === "object") {
      popups = JSON.parse(
        JSON.stringify(popups)
          .replace(
            /extra opdracht(en)?/gi,
            (match, plural) => {
              const base = plural ? "bonusopdrachten" : "bonusopdracht";
              return matchCase(match, base);
            }
          )
          .replace(
            /foto['’]s en filmpjes/gi,
            (match) => matchCase(match, "foto's")
          )
          .replace(
            /photos and videos/gi,
            (match) => {
              return matchCase(match, "Photos");
            }
          )
      );
      console.log("POPUPS", popups);
    }
    let games = [];
    if ((sessionStorage.getItem('token') || auth.getAuthString()).length > 15) {
      if (!window.location.pathname.startsWith('/login')) {
        games = await apiCall('/game');
      }
    }
    Object.keys(data).forEach(key => {
      Defines[key] = data[key];
    });
    Defines.icons = icons;
    Defines.gameLogos = games.map(game => {
      return {
        id: game.id,
        logo: (game.Logo ? game.Logo.url : ""),
        abbreviation: game.abbreviation
      }
    });
    Defines.gamePageGames = games.filter(game => (game.abbreviation !== 'BO') && (game.abbreviation !== 'SS'));
    Defines.gameIcons = gameIcons;
    Defines.position = position;
    Defines.popupLocations = popupLocations;
    Defines.popupLocationsDesktop = popupLocationsDesktop;
    // Fetch popups
    Defines.popups = popups;
    return data;
  }

  static applyLiteOverrides() {
    if (!Defines.popups) return;
    const keys = Object.keys(Defines.popups);
    for (const key of keys) {
      if (key.endsWith('lite')) {
        const baseKey = key.slice(0, -4);
        if (Defines.popups[baseKey]) {
          Defines.popups[baseKey] = { ...Defines.popups[key] };
        }
      }
    }
  }
}

export default Defines;



// WEBPACK FOOTER //
// ./src/Defines.js